<div class="container">
  <div class="row">
    <div class="col-8">
      <div class="row">
        <!-- Header -->
        <div class="text-start">
          <h5 class="poc-header">Products</h5>
        </div>
        <div class="row">
          @for (product of products; track product) {
            <div class="card"
              [ngClass]="{ 'border-orange': product.isOrangeBorder }"
              style="width: 11rem; padding: 0px; position: relative; border: 1px solid #ddd;"
              (click)="!product.isOrangeBorder? toggleProduct(product) : null">
              <img src="../../assets/images/logo.png" class="bd-placeholder-img card-img-top" width="100%"
                height="150">
              <div class="card-body p-3">
                <p class="product-name mb-0">{{ product?.name }}</p>
                <p class="product-name mb-0">{{ product?.description }}</p>
              </div>
              <div class="card-footer d-flex align-items-center justify-content-between price m-0">
                <p style="margin: 0px;">{{ product?.price | number:'0.2-3' }} <small>OMR</small></p>
                @if (product?.quantity > 5) {
                  <span class="text-success">
                  {{product?.quantity}} pcs</span>
                }
                @if (product?.quantity <= 5) {
                  <span class="text-danger">
                  {{product?.quantity}} pcs</span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="col-4 bill">
      <div class="div-color">
        <h6 style="margin-bottom: 0px;">
          <b>Order List</b>
          <span class="float-end" style="font-size: 12px;">{{today | date}}</span>
        </h6>
        <!-- <span>Transaction ID : #65565</span> -->
      </div>
      <div class="div-product">
        <div class="head-text mb-2">
          <h6 class="d-flex align-items-center mb-0">Customer Information</h6>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="input-group flex-grow-1">
            <input class="form-control header-color search-input" [(ngModel)]="patient.name"
              placeholder="customer name ...">
            <input class="form-control header-color search-input" [(ngModel)]="patient.number"
              placeholder="patient mobile ...">
          </div>
          <a class="btn btn-teal btn-icon fs-20" (click)="selectCustomer()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-person-add" viewBox="0 0 16 16">
              <path
                d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
              <path
                d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
            </svg>
          </a>
        </div>
        <div>
          <p class="mb-0 text-left" style="font-size: small;">
            {{patient?.name}} {{patient?.number}}
          </p>
        </div>
      </div>

      <div class="div-product">
        <div class="head-text d-flex align-items-center justify-content-between">
          <h6 class="d-flex align-items-center mb-0">Products Added &nbsp;&nbsp; <span
          class="count">{{this.items.length}}</span>
        </h6>
      </div>

      <table class="table table-borderless mt-2">
        <thead>
          <tr>
            <th class="fw-bold bg-light">Item</th>
            <th class="fw-bold bg-light">QTY</th>
            <th class="fw-bold bg-light text-end">Cost</th>
          </tr>
        </thead>
        <tbody>
          @for (item of items; track item) {
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <h6 class="fs-13 fw-normal">
                    <a class="link-default pe-2" (click)="removeItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                      </svg>
                    </a>
                    <a href="#" class="link-default" data-bs-toggle="modal"
                    data-bs-target="#products">{{item.service_name}}</a>
                  </h6>
                </div>
              </td>
              <td>
                <div class="qty-item m-0 fs-13 fw-normal">
                  {{item.quantity}} {{item?.unit}}
                </div>
              </td>
              <td class="fs-13 fw-semibold text-gray-9 text-end">{{ item.final_price | number:'0.0-3' }}
                <small>OMR</small>
              </td>
            </tr>
          }
          @if (items.length == 0) {
            <tr>
              <td colspan="3">
                <span style="font-style: italic; font-size: small; color:rgb(49, 48, 48);">cart is
                empty</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="div-discount">
      <div class="row">
        <div class="col-12 col-sm-6" data-select2-id="select2-data-27-ihxt">
          <div class="input-block" data-select2-id="select2-data-26-lyoc">
            <label>Discount <span style="font-size: x-small;" dir="auto">(example 5 for
            5%)</span></label>
            <div class="btn-group" role="group" style="width: 100%;">
              <input type="number" class="form-control" [(ngModel)]="bill.discount">
              <button class="btn btn-outline-secondary" type="button" (click)="cal_discount()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-caret-right-fill" viewBox="0 0 16 16">
                  <path
                    d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="div-total">
      <div class="order-total table-responsive">
        <table class="table table-responsive table-borderless">
          <tbody>
            <tr>
              <td>Sub Total</td>
              <td class="text-end">{{bill.sub_total | number:'0.0-3'}} <small>OMR</small></td>
            </tr>
            <tr>
              <td>VAT <span style="font-size: x-small;">({{bill.vat}}%)</span></td>
              <td class="text-end">{{bill.vat_total | number:'0.0-3'}} <small>OMR</small></td>
            </tr>
            <tr>
              <td class="danger">Discount <span
              style="font-size: x-small;">({{bill.discount}}%)</span>
            </td>
            <td class="danger text-end">{{bill.discount_total | number:'0.0-3'}} <small>OMR</small>
          </td>
        </tr>
        <tr>
          <td>Total</td>
          <td class="text-end">{{bill.total | number:'0.0-3'}} <small>OMR</small></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="div-product">
  <div class="head-text d-flex align-items-center justify-content-between">
    <h6 class="d-flex align-items-center mb-0">Payment Method
    </h6>
  </div>
  <div class="row d-flex align-items-center justify-content-center methods">
    <div class="col-md-6 col-lg-6 item" (click)="select_payment('CASH')">
      <div class="default-cover text-center cover-border"
        [ngClass]="{ 'border-orange': bill.method =='CASH'}">
        <a>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-cash-stack" viewBox="0 0 16 16">
            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
            <path
              d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z" />
          </svg> <br>
          <span>Cash</span>
        </a>
      </div>
    </div>
    <div class="col-md-6 col-lg-6 item" (click)="select_payment('CARD')">
      <div class="default-cover text-center cover-border"
        [ngClass]="{ 'border-orange': bill.method =='CARD' }">
        <a>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-credit-card-2-back-fill" viewBox="0 0 16 16">
            <path
              d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1z" />
          </svg> <br>
          <span>Debit Card</span>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="div-total">
  <div class="d-grid btn-block">
    <a class="btn btn-secondary" href="javascript:void(0);" dir="auto">
      Grand Total : {{bill.total | number:'0.0-3'}} <small>OMR</small>
    </a>
  </div>
</div>
<div class="div-pay">
  <div class="d-flex w-100">
    <button type="button" class="btn btn-warning me-2 w-50" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-success me-2 w-50" (click)="make_payment()">Pay</button>
  </div>
</div>
</div>
</div>
</div>